import { jsx as _jsx } from "react/jsx-runtime";
import { Styled } from './RegistrationButtonIframe.styles';
const RegistrationButtonIframe = ({ id, url = 'https://goreg.xing.com', numberButtons = 2, title = 'XING-Registration', }) => {
    const externalLoginButtonHeight = 64;
    const heightWithoutExternalLoginButtons = 242;
    return (_jsx(Styled.DivWithCenteredContent, { children: _jsx(Styled.RegistrationButtonIframe, { src: `${url}/${id}`, height: heightWithoutExternalLoginButtons +
                numberButtons * externalLoginButtonHeight, title: title }) }));
};
export default RegistrationButtonIframe;
//# sourceMappingURL=RegistrationButtonIframe.js.map